import Vue from 'vue'
import Vuex from 'vuex'
import areaLine from './modules/areaLine'
import timeZone from './modules/timeZone'
import delaycertificatetoday from './modules/delaycertificatetoday'
import history from './modules/history'
import externalData from './modules/externalData'
import scroll from './modules/scroll'
import loading from './modules/loading'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    areaLine,
    timeZone,
    history,
    delaycertificatetoday,
    externalData,
    scroll,
    loading
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js